import { Flex, FloraTypography } from '@grupoboticario/flora-react'

import { CASHBACK_BRANDS } from '@/constants/cashbackBrands'
import { formatCurrency } from '@/utils/format/formatCurrency'

import TotalPointsDetails from '../TotalPointsDetails/TotalPointsDetails'
import * as S from './CashbackByBrand.styles'

const CashbackByBrand = ({ totalPoint, totalCashback, totalLoyalty }) => (
  <Flex css={S.balanceRowCss} gap="$4">
    <Flex css={S.balancePanelCss}>
      <TotalPointsDetails totalCashback={totalCashback} totalLoyalty={totalLoyalty} totalPoint={totalPoint} />
    </Flex>

    {CASHBACK_BRANDS.map(({ key, title }) => {
      const brandBalance = totalCashback?.detailByBrand?.[key]

      return (
        <Flex css={S.brandCardCss} direction="column" gap="$2" justify="center" key={key}>
          <FloraTypography css={S.brandTitleCss} fontSize="bodySmallStandard" fontWeight="medium">
            {title}
          </FloraTypography>
          <FloraTypography css={S.brandPointsCss} fontSize="bodySmallStandard">
            {(brandBalance?.point ?? 0).toLocaleString('pt-BR')} pontos
          </FloraTypography>
          <FloraTypography css={S.brandValueCss} fontSize="bodySmallStandard" fontWeight="bold">
            {formatCurrency(brandBalance?.value ?? 0)}
          </FloraTypography>
        </Flex>
      )
    })}
  </Flex>
)

export default CashbackByBrand
